import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Organization } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';

export const GET_ALL_ORGANIZATIONS_KEY = 'get-all-organizations';

export const useGetAllOrganizations = ({ page = 0, size = 10 }: UseGetAllPageSizeProps) =>
  usePermittedQuery<Organization[]>(
    [ACCOUNT_TYPE.ADMIN, ACCOUNT_TYPE.ORG_ADMIN],
    () => `/organization?page=${page}&size=${size}`,
    {},
    [GET_ALL_ORGANIZATIONS_KEY],
    {
      enabled:
        typeof page === 'number' && typeof size === 'number' && page >= 0 && size >= 0,
      refetchOnWindowFocus: false,
    },
  );
